import { RideDelayStatusEnum } from "@ryde/shared";

export const areHiddenDelayStatusesEqual = (
  a: readonly RideDelayStatusEnum[],
  b: readonly RideDelayStatusEnum[],
): boolean => a.length === b.length && a.every(status => b.includes(status));
